import { render, staticRenderFns } from "./msgNotice.vue?vue&type=template&id=21825dc1&scoped=true&"
import script from "./msgNotice.vue?vue&type=script&lang=js&"
export * from "./msgNotice.vue?vue&type=script&lang=js&"
import style0 from "./msgNotice.vue?vue&type=style&index=0&id=21825dc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21825dc1",
  null
  
)

export default component.exports